import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MenuItem } from './../menu.model';
import { IconComponent } from '../../icon/icon.component';
import { IconName } from '@skylab-assets/icons';

@Component({
    selector: 'skl-menu-item',
    templateUrl: './menu-item.component.html',
    imports: [NgClass, IconComponent],
})
export class MenuItemComponent implements OnInit {
    @Input() public item!: MenuItem;
    @Input() public context!: unknown;

    private disabled!: boolean;

    public constructor() {}

    public ngOnInit() {
        this.disabled = this.item?.isDisabled?.(this.context) ?? false;
    }

    public get iconName(): IconName {
        const icon = this.item.icon || this.item.getIcon?.();
        return (icon ? icon.replace(/^icon-/, '') : '') as IconName;
    }

    public getClassNames(): string[] {
        const classNames = [];
        if (this.item.isActive) {
            classNames.push('item-content--active');
        }
        if (this.disabled) {
            classNames.push('item-content--disabled');
        }
        if (this.item.separator) {
            classNames.push('item-content--separator');
        }
        return classNames;
    }
}
